import { TickCircle } from 'iconsax-react'
import { ReceiptText } from 'lucide-react'
import { DialogClose } from '../../../../../components/ui/dialog'
import { Button } from '../../../../../components/ui/button'
import { addMoneySimbols } from '../../../../../../app/utils/formatMoneyValue'
import { useNavigate } from 'react-router-dom'
interface SentProposalProps {
  visible?: boolean
  value?: number | string
  client: string
  title?: string
}
export default function SentProposal({
  visible,
  client,
  value,
  title,
}: SentProposalProps) {
  const navigate = useNavigate()
  const backToDashboard = () => navigate('/')

  console.log(typeof value, 'value')
  return (
    <div className={visible ? 'flex flex-col gap-8' : 'hidden'}>
      <div className="flex flex-col items-start gap-1.5">
        <TickCircle variant="Bold" size={40} className="text-success" />
        <strong className="font-semibold">Proposta realizada</strong>
        <p className="text-sm font-medium text-black04">
          A proposta está em andamento, você receberá uma notificação caso a
          transação for concluída
        </p>
      </div>
      <div className="flex flex-col items-start gap-1.5">
        <p className="text-sm font-medium">{title ? title : 'Valor'}</p>
        <h3 className="text-3xl font-semibold">
          {typeof value === 'number' ? addMoneySimbols(value ?? 0) : value}
        </h3>
        <p className="text-sm font-medium text-black04">
          Para <strong className="font-semibold text-black01">{client}</strong>
        </p>
      </div>
      <div
        className="flex cursor-pointer items-center justify-center gap-2.5 rounded-2xl border border-black04 p-4 font-medium max-sm:p-3 max-sm:text-sm"
        onClick={backToDashboard}
      >
        <ReceiptText className="max-sm:h-4 max-sm:w-4" />
        Voltar para o inicio
      </div>
      <DialogClose className="flex justify-end max-sm:justify-center">
        <Button
          className="rounded-full px-8 py-3 font-semibold text-white max-sm:w-full"
          onClick={backToDashboard}
        >
          Concluir
        </Button>
      </DialogClose>
    </div>
  )
}
